import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BuildIcon from "@mui/icons-material/Build";
import CancelIcon from "@mui/icons-material/Cancel";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EmailIcon from "@mui/icons-material/Email";
import ApiIcon from "@mui/icons-material/Api";
import SaveIcon from "@mui/icons-material/Save";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  InputAdornment,
  Paper,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import ResponsiveDialog from "../../component/dialog/dialog";
import DrawerPrincipal from "../../component/drawer/drawer-principal";
import { usePermissions } from "../../contexts/permissionsContext";
import usePermissionCheck from "../../hooks/usePermissionCheck";
import { getErrorMessage } from "../../service/api";
import configurationService from "../../service/configurationService";

function InsertConfiguration() {
  const { getPermission } = usePermissions();
  const { checkPermissionWithRefresh, permissionError, clearPermissionError } = usePermissionCheck();

  // Obter permissão de Configuração do sistema centralizado
  const permission = getPermission("Configuração");


  const [idConfiguracao, setIdConfiguracao] = useState();
  const [emailLog, setEmailLog] = useState("");
  const [accountCurrentOmie, setAccountCurrentOmie] = useState("");
  const [superNumberPanelOmie, setSuperNumberPanelOmie] = useState("");
  const [userId, setUserId] = useState("");
  const [nameEnvironment, setNameEnvironment] = useState("");
  const [nameEnvironmentError, setNameEnvironmentError] = useState("");

  const [emailLogError, setEmailLogError] = useState("");
  const [accountCurrentOmieError, setAccountCurrentOmieError] = useState("");
  const [superNumberPanelOmieError, setSuperNumberPanelOmieError] = useState("");
  const [idApi, setIdApi] = useState("");
  const [idApiError, setIdApiError] = useState("");

  const [openDialog, setOpenDialog] = useState();
  const [messageDialog, setMessageDialog] = useState();
  const [titleDialog, setTitleDialog] = useState();
  const [statusDialog, setStatusDialog] = useState();

  const { id } = useParams();

  let navigate = useNavigate();

  // Inicializar userId do usuário logado
  useEffect(() => {
    if (!id) {
      // Só inicializa userId se estiver criando (não editando)
      const userToken = localStorage.getItem("user_token");
      if (userToken) {
        try {
          const user = JSON.parse(userToken);
          const currentUserId = user?.iduser || user?.id || null;
          if (currentUserId) {
            setUserId(currentUserId);
          }
        } catch (error) {
          console.error("Erro ao obter userId do localStorage:", error);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    (async () => {
      // Só carrega dados se estiver no modo de edição (quando há id)
      if (id) {
        try {
          const response = await configurationService.editConfiguration(id);
          if (
            response.status === 200 ||
            response.status === 201 ||
            response.success === true
          ) {
            const item = response.data;
            console.log("🔍 [InsertConfiguration] Dados recebidos da API:", item);
            console.log("🔍 [InsertConfiguration] ID:", item?.idconfiguration || item?.id);
            console.log("🔍 [InsertConfiguration] Nome:", item?.environment || item?.name || item?.nameEnvironment);
            
            // Mapeia ID (pode vir como idconfiguration ou id)
            setIdConfiguracao(item?.idconfiguration || item?.id);
            
            setEmailLog(item?.emailLog || "");
            setAccountCurrentOmie(item?.accountCurrentOmie || "");
            setSuperNumberPanelOmie(item?.superNumberPanelOmie || "");
            setUserId(item?.userId || item?.iduser || "");
            
            // Mapeia nome do ambiente (pode vir como environment, name ou nameEnvironment)
            setNameEnvironment(item?.environment || item?.name || item?.nameEnvironment || "");
            
            setIdApi(
              item?.idOmieSecret !== undefined && item?.idOmieSecret !== null
                ? String(item.idOmieSecret)
                : ""
            );
          } else {
            setOpenDialog(true);
            setStatusDialog("error");
            setTitleDialog("Ops!");
            setMessageDialog(getErrorMessage(response) || "Erro ao buscar Configurações");
          }
        } catch (error) {
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops!");
          setMessageDialog(getErrorMessage(error) || "Erro ao buscar Configurações");
        }
      }
    })();
  }, [id]);



  const cancel = () => {
    navigate("/listConfiguration");
  };

  async function save() {
    try {
      // Verificar permissão antes de criar
      const hasPermission = await checkPermissionWithRefresh("Configuração", "isinsert", true, false);
      if (!hasPermission) {
        return; // A função checkPermissionWithRefresh já mostra o dialog de erro
      }

      if (valid()) {
        // Obter userId do usuário logado
        const userToken = localStorage.getItem("user_token");
        let currentUserId = userId;
        
        if (!currentUserId && userToken) {
          try {
            const user = JSON.parse(userToken);
            currentUserId = user?.iduser || user?.id || null;
          } catch (error) {
            console.error("Erro ao obter userId do localStorage:", error);
          }
        }

        var data = {
          emailLog: emailLog,
          accountCurrentOmie: accountCurrentOmie,
          superNumberPanelOmie: superNumberPanelOmie,
          userId: currentUserId,
          environment: nameEnvironment,
          idOmieSecret: idApi,
        };

        const response = await configurationService.create(data);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.success === true
        ) {
          handleDialogOpen();
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog(
            response.message || "Configuração cadastrada com sucesso"
          );
        } else {
          handleDialogOpen();
          setStatusDialog("error");
          setTitleDialog("Ops!");
          setMessageDialog(response.message || "Erro ao cadastrar configuração");
        }
      }
    } catch (error) {
      handleDialogOpen();
      setStatusDialog("error");
      setTitleDialog("Ops!");
      setMessageDialog(error.message || "Erro ao cadastrar configuração");
    }
  }

  async function update() {
    try {
      // Verificar permissão antes de atualizar
      const hasPermission = await checkPermissionWithRefresh("Configuração", "isinsert", true, false);
      if (!hasPermission) {
        return; // A função checkPermissionWithRefresh já mostra o dialog de erro
      }

      if (valid()) {
        // Obter userId do usuário logado
        const userToken = localStorage.getItem("user_token");
        let currentUserId = userId;
        
        if (!currentUserId && userToken) {
          try {
            const user = JSON.parse(userToken);
            currentUserId = user?.iduser || user?.id || null;
          } catch (error) {
            console.error("Erro ao obter userId do localStorage:", error);
          }
        }

        var data = {
          idconfiguration: idConfiguracao,
          emailLog: emailLog,
          accountCurrentOmie: accountCurrentOmie,
          superNumberPanelOmie: superNumberPanelOmie,
          userId: currentUserId,
          environment: nameEnvironment,
          idOmieSecret: idApi,
          updatedAt: new Date(),
        };

        const response = await configurationService.update(data);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.success === true
        ) {
          handleDialogOpen();
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog(
            response.message || "Configuração atualizada com sucesso"
          );
          
          // Redirecionar para lista de configurações após 2 segundos
          setTimeout(() => {
            navigate("/listConfiguration");
          }, 2000);
        } else {
          handleDialogOpen();
          setStatusDialog("error");
          setTitleDialog("Ops!");
          setMessageDialog(response.message || "Erro ao atualizar configuração");
        }
      }
    } catch (error) {
      handleDialogOpen();
      setStatusDialog("error");
      setTitleDialog("Ops!");
      setMessageDialog(error.message || "Erro ao atualizar configuração");
    }
  }

  function valid() {
    let thatsOk = true;

    if (!emailLog) {
      setEmailLogError("O e-mail de log precisa ser preenchido");
      thatsOk = false;
    }
    if (!accountCurrentOmie) {
      setAccountCurrentOmieError("A conta atual omit precisa ser preenchida");
      thatsOk = false;
    }
    if (!superNumberPanelOmie) {
      setSuperNumberPanelOmieError("O super número do painel omit precisa ser preenchido");
      thatsOk = false;
    }
    return thatsOk;
  }
  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    navigate("/");
  };


  return (
    <>
      <Container maxWidth="lx" sx={{ bgcolor: "#EBEBEB", height: "100vh" }}>
        <DrawerPrincipal
          divOpen={
            <div>
              <div>
                <div className="row mb-3">
                  <CustomizedBreadcrumbs
                    title1={"Home"}
                    link1={"/"}
                    title2={"Lista de Configurações"}
                    link2={"/listConfiguration"}
                    title3={id ? "Editar Configuração" : "Nova Configuração"}
                    link3={"#"}
                  />
                </div>
                <ResponsiveDialog
                  open={openDialog}
                  handleClose={handleDialogClose}
                  title={titleDialog}
                  message={messageDialog}
                  status={statusDialog}
                />

                <Paper
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
                  }}
                >
                  <Box sx={{ p: 4 }}>
                    <Card
                      sx={{
                        borderRadius: 2,
                        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
                        background: "linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)",
                        border: "1px solid rgba(0,0,0,0.05)"
                      }}
                    >
                      <CardContent sx={{ p: 4 }}>
                        <Box sx={{ mb: 3 }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <SettingsIcon sx={{ fontSize: 40, color: "primary.main" }} />
                            <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: "text.primary" }}>
                              {id ? "Editar Configuração" : "Nova Configuração"}
                            </Typography>
                          </Box>
                        </Box>

                        <Divider sx={{ mb: 4 }} />

                        <Grid container spacing={3}>

                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Nome do ambiente"
                              variant="outlined"
                              placeholder="Nome do ambiente"
                              disabled={!permission?.isinsert}
                              required
                              value={nameEnvironment || ""}
                              onChange={(e) => {
                                setNameEnvironment(e.target.value);
                                setNameEnvironmentError("");
                              }}
                              error={!!nameEnvironmentError}
                              helperText={nameEnvironmentError || "Nome do ambiente"}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <BuildIcon sx={{ color: "primary.main" }} />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "&:hover fieldset": {
                                    borderColor: "primary.main",
                                  },
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="E-mail de Log"
                              variant="outlined"
                              placeholder="E-mail de Log"
                              disabled={!permission?.isinsert}
                              value={emailLog || ""}
                              onChange={(e) => {
                                setEmailLog(e.target.value);
                                setEmailLogError("");
                              }}
                              error={!!emailLogError}
                              helperText={emailLogError || "E-mail utilizado para envio de logs do sistema"}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <EmailIcon sx={{ color: "primary.main" }} />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "&:hover fieldset": {
                                    borderColor: "primary.main",
                                  },
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Conta Corrente para envio OMIE"
                              variant="outlined"
                              placeholder="Conta Corrente para envio OMIE"
                              required
                              disabled={!permission?.isinsert}
                              value={accountCurrentOmie || ""}
                              onChange={(e) => {
                                setAccountCurrentOmie(e.target.value);
                                setAccountCurrentOmieError("");
                              }}
                              error={!!accountCurrentOmieError}
                              helperText={accountCurrentOmieError || "Conta Corrente para envio OMIE"}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <AccountCircleIcon sx={{ color: "primary.main" }} />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "&:hover fieldset": {
                                    borderColor: "primary.main",
                                  },
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Número painel Pai"
                              variant="outlined"
                              placeholder="Número painel Pai"
                              required
                              disabled={!permission?.isinsert}
                              value={superNumberPanelOmie || ""}
                              onChange={(e) => {
                                setSuperNumberPanelOmie(e.target.value);
                                setSuperNumberPanelOmieError("");
                              }}
                              error={!!superNumberPanelOmieError}
                              helperText={superNumberPanelOmieError || "Número do Painel pai para envio OMIE"}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <DashboardIcon sx={{ color: "primary.main" }} />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "&:hover fieldset": {
                                    borderColor: "primary.main",
                                  },
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                          <TextField
                              fullWidth
                              label="Id da API"
                              variant="outlined"
                              placeholder="Id da API"
                              required
                              disabled={!permission?.isinsert}
                              value={idApi || ""}
                              onChange={(e) => {
                                setIdApi(e.target.value);
                                setIdApiError("");
                              }}
                              error={!!idApiError}
                              helperText={idApiError || "Id da API"}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <ApiIcon sx={{ color: "primary.main" }} />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "&:hover fieldset": {
                                    borderColor: "primary.main",
                                  },
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 2,
                        mt: 4,
                        pt: 3,
                        borderTop: "1px solid rgba(0,0,0,0.1)",
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={cancel}
                        startIcon={<CancelIcon />}
                        sx={{
                          px: 3,
                          py: 1.5,
                          textTransform: "none",
                          fontSize: "1rem",
                          fontWeight: 500,
                        }}
                      >
                        Cancelar
                      </Button>
                      {permission?.isinsert ? (
                        <Button
                          variant="contained"
                          onClick={id ? update : save}
                          startIcon={<SaveIcon />}
                          sx={{
                            px: 4,
                            py: 1.5,
                            textTransform: "none",
                            backgroundColor: "#000000",
                            fontSize: "1rem",
                            fontWeight: 500,
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                            "&:hover": {
                              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
                            },
                          }}
                        >
                          {id ? "Atualizar Configuração" : "Salvar Configuração"}
                        </Button>
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{
                            color: "error.main",
                            fontSize: "0.875rem",
                            fontStyle: "italic",
                            alignSelf: "center",
                            px: 2,
                          }}
                        >
                          Você não tem permissão para {id ? "editar" : "criar"} configurações
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Paper>
              </div>
            </div>
          }
        />
      </Container>

      {/* Dialog de erro de permissão */}
      <ResponsiveDialog
        open={!!permissionError}
        handleClose={clearPermissionError}
        title={permissionError?.title || "Erro de Permissão"}
        message={permissionError?.message || "Você não tem permissão para acessar este recurso."}
        status={permissionError?.type || "warning"}
      />
    </>
  );
}
export default InsertConfiguration;
